module.exports = __webpack_public_path__ + "static/media/img_feature_photo1@2x.332dd5ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_feature_photo1@2x.jpg
// module id = 790
// module chunks = 0